"use strict";
// notification push service guide here https://codelabs.developers.google.com/codelabs/push-notifications#0
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const apiService_1 = __importDefault(require("./apiService"));
let globalRegistration = null;
const registerServiceWorker = () => {
    const hrefWithoutQueryParams = window.location.href.split('?')[0];
    const scope = hrefWithoutQueryParams
        .split('/')
        .slice(0, 4)
        .join('/');
    if ('serviceWorker' in navigator && 'PushManager' in window) {
        navigator.serviceWorker
            .register(`/push-service-worker.js?id=${scope}`)
            .then(function (registration) {
            console.log('Service Worker is registered', registration);
            globalRegistration = registration;
        })
            .catch(function (error) {
            console.error('Service Worker Error', error);
        });
    }
    else {
        console.warn('Push messaging is not supported');
    }
};
registerServiceWorker();
const enablePushService = (publicKey_1, userToken_1, currentLocale_1, ...args_1) => __awaiter(void 0, [publicKey_1, userToken_1, currentLocale_1, ...args_1], void 0, function* (publicKey, userToken, currentLocale, ignoreApiCall = false) {
    if (!globalRegistration) {
        return;
    }
    globalRegistration.pushManager
        .getSubscription()
        .then(function (subscription) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('subscription', subscription);
            if (subscription) {
                enableInServer(subscription, currentLocale, userToken);
            }
            else {
                const newSubscription = yield globalRegistration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: base64UrlToUint8Array(publicKey),
                });
                if (!ignoreApiCall) {
                    enableInServer(newSubscription, currentLocale, userToken);
                }
            }
        });
    })
        .catch(function (error) {
        console.log('Error getting subscription', error);
    });
});
const disablePushService = (userToken, currentLocale) => __awaiter(void 0, void 0, void 0, function* () {
    if (!globalRegistration) {
        return;
    }
    globalRegistration.pushManager
        .getSubscription()
        .then(function (subscription) {
        if (subscription) {
            subscription
                .unsubscribe()
                .then(function () {
                disableInServer(currentLocale, userToken);
            })
                .catch(function (error) {
                console.log('Error unsubscribing', error);
            });
        }
    })
        .catch(function (error) {
        console.log('Error getting subscription', error);
    });
});
const requestNotificationPermission = (publicKey_2, userToken_2, currentLocale_2, ...args_2) => __awaiter(void 0, [publicKey_2, userToken_2, currentLocale_2, ...args_2], void 0, function* (publicKey, userToken, currentLocale, setToggleTo = () => { }) {
    const permission = yield Notification.requestPermission();
    if (permission === 'granted') {
        setToggleTo(true);
        enablePushService(publicKey, userToken, currentLocale);
    }
    else {
        setToggleTo(false);
        disableInServer(currentLocale, userToken);
    }
});
// just an event listener for permission change, not used right now but might be usefull in the future
// looks like this doesn't work when changing permissions on ios PWA :( , still keeping it tho, who knows
// const listenToPermissionChanges = async( onChange: Function ) => {
//     navigator.permissions.query( { name: "notifications" } ).then( function( notificationPerm ) {
//         // eslint-disable-next-line no-param-reassign
//         notificationPerm.onchange = function() {
//             console.log( `User decided to change his seettings. New permission: ${ notificationPerm.state }` );
//
//             onChange( notificationPerm.state );
//         };
//     } );
// };
function enableInServer(subscription, currentLocale, userToken) {
    const body = {
        web_push_subscription: subscription.toJSON(),
        push_notification_enabled: true,
    };
    apiService_1.default.sendPushSubscription(currentLocale, userToken, body);
}
function disableInServer(currentLocale, userToken) {
    const body = {
        web_push_subscription: '',
        push_notification_enabled: false,
    };
    apiService_1.default.sendPushSubscription(currentLocale, userToken, body);
}
function getSubscription() {
    if (!globalRegistration) {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject('no global registration');
    }
    return globalRegistration.pushManager.getSubscription();
}
// Converts the URL-safe base64 encoded |base64UrlData| to an Uint8Array buffer.
function base64UrlToUint8Array(base64UrlData) {
    const padding = '='.repeat((4 - (base64UrlData.length % 4)) % 4);
    const base64 = (base64UrlData + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const buffer = new Uint8Array(rawData.length);
    /* eslint-disable no-plusplus */
    for (let i = 0; i < rawData.length; ++i) {
        buffer[i] = rawData.charCodeAt(i);
    }
    return buffer;
}
exports.default = {
    registerServiceWorker,
    enablePushService,
    disablePushService,
    requestNotificationPermission,
    disableInServer,
    getSubscription,
};
